import { render, staticRenderFns } from "./PostsFilterSelections.vue?vue&type=template&id=e0501440&"
import script from "./PostsFilterSelections.vue?vue&type=script&lang=js&"
export * from "./PostsFilterSelections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports